import '@babel/polyfill'

import Vue from 'vue'

import BouncePreventor from '@/shared/components/BouncePreventor/BouncePreventor.vue'
import InstashareTimer from './components/InstashareTimer'
import TeamThornModal from './components/TeamThornModal/TeamThornModal'
import PreOrderSearchEmail from './components/PreOrderSearchEmail/PreOrderSearchEmail'
import VueAxios from 'vue-axios'
import axios from 'axios'
import store from '@/shared/components/EmailSearch/store'

import { MediaQueries } from 'vue-media-queries'
import { VueMasonryPlugin } from '@/shared/lib/vendor/vue-masonry'

Vue.use(VueAxios, axios)

const mediaQueries = new MediaQueries()
Vue.use(mediaQueries)

Vue.use(VueMasonryPlugin)

/* eslint-disable no-new */
new Vue({
  el: '#v-app-proofs-index',
  mediaQueries,
  components: {
    BouncePreventor,
    InstashareTimer,
    TeamThornModal,
    PreOrderSearchEmail
  },
  computed: {
    getMasonryColumnWidth () { // determines what element selector to use to determine Masonry column-width attribute
      const defaultGridItemClass = '.grid-item'
      const landscapeGridItemClass = '.grid-item--width-2'

      const gridHasPortraitImages = document.getElementById('main-photo-gallery').querySelectorAll(defaultGridItemClass + ':not(' + landscapeGridItemClass + ')').length > 0

      if (gridHasPortraitImages === true) {
        return defaultGridItemClass + ':not(' + landscapeGridItemClass + ')' // column width config will run just off portrait grid item class
      } else {
        return landscapeGridItemClass // column width config will run off of landscape grid item class
      }
    }
  },
  created () {
    document.addEventListener('gallery-image-removed', () => {
      this.$redrawVueMasonry()
    })
  },
  destroyed () {
    document.removeEventListener('gallery-image-removed')
  },
  store
})



// WEBPACK FOOTER //
// ./WebResources/vue/proofs/index/main.js